/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Thu Nov 05 2026 10:58:36 GMT+0100 (Central European Standard Time)
 * Language keys:  283
 * Language code:  fr
 *
 */

const language = {
  "Login_Login": "Se connecter",
  "Login_Login_SubText": "Connectez-vous à l'aide de votre nom d'utilisateur et de votre mode de passe.",
  "Login_RememberMe": "Se souvenir de moi",
  "Login_Helpdesk_1": "Vous avez des problèmes pour vous connecter ?",
  "Login_Helpdesk_2": "Contacter le helpdesk.",
  "Login_SavedUsers": "Utilisateurs qui se sont connectés précédemment",
  "Login_SavedUsers_LastLoggedIn": "Dernière connexion %{date} à %{time}",
  "Main_Filter": "Filtre",
  "Main_Filter_External": "Filtrer sur base de l'ID externe",
  "Main_Filter_Name": "Filtrer sur base du nom",
  "Main_Filter_Alarm": "Niveau d'alarme",
  "Main_Filter_Alarm_Red": "Rouge (priorité maximale)",
  "Main_Filter_Alarm_Orange": "Orange (urgent)",
  "Main_Filter_Alarm_Green": "Vert (priorité faible / test)",
  "Main_Filter_Time": {
    "0": "Plage de dates",
    "Start": "Date de début",
    "End": "Date de fin"
  },
  "Main_OpenAlarms": "Alarmes ouvertes",
  "Main_ClosedAlarms": "Alarmes acquittées",
  "Main_ShowMore": "Charger plus",
  "Main_OpenAlarms_MadeBy": "Créé par",
  "Main_OpenAlarms_Today": "Aujourd'hui",
  "Main_OpenAlarms_Company": "Client",
  "Main_By": {
    "Customer": "Par **%{alarmCreator} - %{customer}**",
    "No_Customer": " Par **%{alarmCreator}**"
  },
  "TopBar_Title": "Pour les opérateurs de la centrale d'alarme",
  "TopBar_Settings": "Paramètres",
  "TopBar_Tutorial": "Vidéo explicative",
  "TopBar_Sound_Muted": "En mode silencieux",
  "TopBar_Logout_Text": "Êtes-vous sûr de vouloir vous déconnecter ?",
  "Main_Filter_Alarm_Test_Plural": "Vert : tests",
  "Main_Filter_Alarm_Assistance_Plural": "Orange : fournir une assistance",
  "Main_Filter_Alarm_Panic_Plural": "Rouge : fournir de l'aide",
  "Main_OpenAlarms_Yesterday": "Hier",
  "Menu_Linked": "Client connecté",
  "Menu_Linked_Sub": "Vous avez accès à plusieurs clients. Sélectionnez un client ci-dessous pour vous connecter.",
  "Menu_LinkedLast": "Clients qui se sont connectés récemment",
  "Menu_LinkedLast_Sub": "Cliquer pour se connecter rapidement",
  "Menu_Language": "Langue",
  "Dates": {
    "At": "à",
    "Last": "Dernier",
    "Yesterday": "Hier",
    "Today": "Aujourd'hui",
    "Tomorrow": "Demain",
    "Now": "Maintenant"
  },
  "AlarmDetails_Extern": "ID externe",
  "AlarmDetails_Customer": "Société/client",
  "Address_CurrentPos": "Position actuelle",
  "Address_CurrentPos_Meter_Plural": "mètres",
  "Address_CurrentPos_Meter": "mètre",
  "Address_Inside_Cap": "À l'intérieur",
  "Address_Inside": "se trouve à l'intérieur à",
  "Address_Outside": "est",
  "Address_AlarmPos": "Position de l'alarme",
  "TopBar_Alarms": "Aperçu de l'alarme",
  "TopBar_AlarmDetails": "Détails de l'alarme",
  "TopBar_Main": "X-Guard Alarm Manager",
  "Helpers_WhoHelp": "Intervenants",
  "AlarmMap_Map": "Carte",
  "Protocol_Response": "Procédure de suivi",
  "Responder_Customer_Title": "Client",
  "Responder_QuickResponse_Title": "Personnes à proximité",
  "Responder_Group_Customer": "Origine de l'alarme",
  "Responder_Group_RA": "Zone de réaction",
  "Responder_Group_PC": "Contacts",
  "Responder_Group_QR": "Personnes à proximité",
  "Responder_Group_NQR": "Réaction nationale",
  "Responder_Group_BasedDistance": "En fonction de la distance",
  "Helpers_Tooltip": "Les personnes mentionnées ici ont confirmé avoir répondu à l'alarme. Elles sont susceptibles d'avoir reçu un appel automatique les informant de l'alarme. Consultez le journal d'événement pour plus de détails.",
  "Helpers_None": "Personne n'a confirmé sa réaction à cette alarme.",
  "Error_Validation_DuplicateValue": "'Reproduire la valeur' a été ignoré",
  "Main_Filter_External_Placeholder": "ID externe",
  "Main_Filter_Name_Placeholder": "Nom",
  "Main_Filter_Time_Start_Placeholder": "Date et heure de début",
  "Main_Filter_Time_End_Placeholder": "Date et heure de fin",
  "Warning_AlarmFilter_Active": "Attention : des filtres sont activés",
  "Alarm_Detail_Log_Title": "Journal d'événement / chat",
  "Alarm_Detail_Log_Messages": "Message",
  "Alarm_Detail_Log_AddMessages": "Saisir un message",
  "Alarm_Detail_Log_AddMessagesDisabled": "La fonction 'ajouter des messages' n'est pas disponible",
  "Alarm_Detail_Log_OpenLog": "Ouvrir le journal d'événement",
  "Alarm_Detail_Log_CloseLog": "Fermer le journal d'événement",
  "Alarm_Detail_Log_No_Messages": "Aucun événement n'a été enregistré",
  "Alarm_Detail_Log_Action_Confirmation_True": "Je vais intervenir pour cette alarme",
  "Alarm_Detail_Log_Action_Confirmation_False": "Je ne vais PAS intervenir pour cette alarme",
  "Alarm_Detail_Log_Action_Call": "Appel passé à %{name}",
  "Alarm_Detail_Log_Action_Notification": "Notification envoyée à %{name}",
  "Alarm_Detail_Log_Action_Sms": "SMS envoyé à %{name}",
  "Alarm_Detail_Log_Action_Acknowledge": "Alarme acquittée",
  "Alarm_Detail_Log_Action_Call_Initiated": "Pourrait avoir appelé / cliqué sur l'icône d'appel pour %{name}",
  "Alarm_Detail_Log_System_Escalated_AlarmCenter": "L'alarme a été renvoyée à la centrale d'alarme",
  "Alarm_Detail_Log_Action_AcknowledgeMessage": {
    "app": "J'ai acquitté cette alarme de l'application X-Guard Alarm.",
    "web": "Cette alarme a été clôturée à l'aide du X-Guard Alarm Manager"
  },
  "Alarm_Detail_Log_Action_System_AcknowledgeMessage": "Cette alarme a été acquittée automatiquement",
  "Alarm_Detail_Log_Action_Manual_Notification": "L'alarme a été partagée avec %{name} (appel téléphonique automatique + sms)",
  "Alarm_Detail_Log_LoadingMoreMessagesStatus": "Chargement des messages",
  "Alarm_Detail_Log_LoadingMessagesStatus": "Chargement des messages",
  "Alarm_Detail_Log_NewMessagesCallToAction": {
    "one": "Un nouveau journal d'événement / message chat a été ajouté&nbsp;",
    "other": "Plusieurs journaux d'événements / messages Chat ont été ajoutés"
  },
  "Alarm_Acknowledged": "L'alarme a été acquittée",
  "Menu_Linked_Placeholder": "Sélectionner un client",
  "Menu_Updates": "Quoi de neuf ?",
  "Languages": {
    "English": "Anglais",
    "Dutch": "Néerlandais",
    "French": "Français"
  },
  "Login": {
    "Placeholders": {
      "Username": "Nom d'utilisateur",
      "Password": "Mot de passe"
    },
    "Failed": "Vos identifiants de connexion n'étaient pas exacts",
    "Query_Token": {
      "Pending": "En cours d'authentification...",
      "Success": "Vous êtes maintenant connecté",
      "Error": "L'authentification a échoué"
    },
    "Message": {
      "TokenExpired": "Votre session a expiré. Veuillez procéder à une nouvelle authentification.",
      "TokenInvalid": "Session non valable, veuillez procéder à une nouvelle authentification."
    }
  },
  "Alarm_Detail_Contact": {
    "Push_Message": {
      "Subtitle": "L'alarme sera partagée à l'aide d'une notification push mobile.",
      "Title": "Message push"
    },
    "Automatic_Phone_Message": {
      "Subtitle": "Les détails de l'alarme seront partagés à l'aide d'un appel automatique et d'un SMS.",
      "Title": "Message téléphonique automatique"
    },
    "Phone_Call": {
      "Title": "Appeler",
      "Subtitle": "Appeler directement la personne.",
      "Done": "Fait",
      "Instructions": "Composez le numéro ci-dessous ou cliquez sur celui-ci pour démarrer l'appel..\n\n(Jusqu'à deux appels)",
      "Result": {
        "Responding": "La personne appelée va intervenir",
        "Not_Reachable": "La personne appelée n'interviendra PAS",
        "No_Response": "Il n'a pas été possible de joindre la personne appelée",
        "Title": "Comment s'est passé l'appel ?",
        "Skipped": "Annuler l'appel",
        "Wrong_Number": "Le numéro de téléphone est incorrect"
      },
      "AlarmCreator": {
        "Result": {
          "Responding": "La personne qui a créé l'alarme n'a pas besoin d'aide",
          "Not_Reachable": "La personne qui a créé l'alarme a besoin d'aide",
          "No_Response": "N'a pas pu être contacté"
        }
      }
    },
    "Sms_Message": {
      "Title": "SMS",
      "Subtitle": "L'alarme sera partagée à l'aide d'un SMS.",
      "Output": {
        "Title": "Modèle de SMS"
      },
      "Toast": {
        "Error": "Un problème s'est produit durant l'envoi du SMS",
        "Sending": "SMS en cours d'envoi...",
        "Sent": "Un SMS a été envoyé"
      }
    },
    "Email": {
      "Title": "Rédiger un e-mail",
      "Subtitle": {
        "one": "L'alarme sera partagée à l'aide d'un courriel.",
        "other": "L'alarme sera partagée à l'aide d'un courriel."
      },
      "Output": {
        "Title": "Prévisualiser le message"
      },
      "Subject": "X-Guard - Une alarme a été partagée avec vous",
      "Toast": {
        "Sending": "E-mail en cours d'envoi...",
        "Sent": "E-mail envoyé !",
        "Error": "Une erreur s'est produite durant l'envoi du mail"
      }
    },
    "Title": "Contact %{name}",
    "Builder_Form": {
      "Add_Data": {
        "Title": "Ajouter des informations concernant l'alarme",
        "Fields": {
          "Alarm_Position": "Position de l'alarme",
          "Personal_Information": "Informations personnelles",
          "Include_Contact_Code": "Code contrat / contact",
          "Name": "Nom",
          "Current_Position": "Position actuelle"
        }
      },
      "Message": {
        "Title": "Saisir un message",
        "Subtitle": "Voulez-vous que cette personne vous rappelle ? Si oui, indiquez votre numéro de téléphone et les consignes pour l'appel.",
        "Placeholder": "Saisissez votre message ici...",
        "Choose_Template": "Ouvrir un document type"
      },
      "Send": "Soumettre"
    },
    "In_Call": {
      "Alarm_Call": "%{name} est déjà dans l'appel d'alarme et directement joignable.\nConnectez-vous avec le code ci-dessous.\nPlus rapide que d'appeler le numéro : vous parlez tout de suite.",
      "Helper_Call": "%{name} est déjà dans l'appel des intervenants et directement joignable.\nConnectez-vous avec le code ci-dessous.\nPlus rapide que d'appeler le numéro : vous parlez tout de suite.",
      "Other_Options": "Autres options de contact",
      "Can_Talk": "Vous pouvez déjà parler avec %{name}.\nVous êtes tous les deux dans cet appel."
    }
  },
  "Alarm_Detail_Acknowledge": {
    "Title": "Alarme active",
    "Subtitle": "N'acquittez pas cette alarme jusqu'à ce qu'une assistance ait été fournie et que la situation (de détresse) ait été complètement résolue. Toutes les communications relatives à cette alarme seront désactivées lorsque celle-ci aura été acquittée.",
    "Button_Label": "Acquitter l'alarme",
    "Survey": {
      "Title": "Vue d'ensemble de l'acquittement de l'alarme",
      "customerHappy": {
        "Title": "La personne qui a créé l'alarme est-elle satisfaite de la manière dont celle-ci a été gérée ?"
      },
      "Item": {
        "yes": "Oui",
        "no": "Non",
        "unknown": "Ignoré",
        "notApplicable": "N/A",
        "other": "Autre",
        "skipped": "Ignorer",
        "noAudioConnection": "Il n'y a pas eu d'appel",
        "noSoundOnConnection": "Il y a eu un appel, mais on n'a rien entendu",
        "noHumanResponse": "Il y a eu un appel, mais il était incompréhensible",
        "notAccurate": "Faible précision GPS",
        "notAvailable": "Il n'y avait aucune information sur la position",
        "incorrectAddress": "L'adresse affichée n'était pas correcte",
        "notUpToDate": "La localisation n'était pas à jour"
      },
      "audioQualityOk": {
        "Title": "L'appel téléphonique / la connexion audio ont-ils fonctionné correctement ?"
      },
      "audioQualityFeedback": {
        "Title": "Que s'est-il passé au niveau de l'appel téléphonique / de la connexion audio ?"
      },
      "responseOk": {
        "Title": "La réaction a-t-elle bien été définie ?"
      },
      "responseFeedback": {
        "Title": "Veuillez décrire le problème survenu au niveau des options de réaction définies",
        "Placeholder": "Soyez bref mais précis",
        "Label": "Continuer"
      },
      "positionOk": {
        "Title": "Les données de localisation étaient-elles exactes ?"
      },
      "positionFeedback": {
        "Title": "Veuillez décrire le problème survenu au niveau des informations concernant la position"
      },
      "comment": {
        "Title": "Notes d'acquittement",
        "Placeholder": "Veuillez résumer l'alarme",
        "Label": "Acquitter l'alarme"
      }
    },
    "Comment": {
      "customerHappy": "**Client satisfait**\n%{message}",
      "audioQualityOk": "**Qualité Audio OK**\n%{message}",
      "audioQualityFeedback": "**Feedback qualité audio**\n%{message}",
      "responseOk": "**Réaction OK**\n%{message}",
      "responseFeedback": "**Feedback réaction**\n%{message}",
      "positionFeedback": "**Feedback position**\n%{message}",
      "positionOk": "**Position OK**\n%{message}",
      "comment": "**Commentaire**\n%{message}"
    },
    "Toast": {
      "Pending": "Acquittement en cours...",
      "Success": "L'alarme a été acquittée avec succès",
      "Error": "L'acquittement de l'alarme a échoué"
    },
    "Blocked": "Cette alarme est gérée par '%{name}'. Vous ne pouvez pas acquitter les alarmes qui sont gérées.",
    "BlockedByAlarmProfessionalResponder": "Cette alarme est actuellement en contact avec un service d'intervention professionnel. Veuillez terminer votre intervention avant de confirmer la prise en charge de l'alarme.",
    "ActiveCall": "Si vous clôturez l'alarme maintenant, la communication sera coupée pour tous les intervenants."
  },
  "Menu_Linked_No_Customers_Found": "Aucun client trouvé",
  "Alarm_Detail_Response_Protocol_Panic": "- NE PARLEZ PAS ! \n- Connectez-vous et écoutez l'appel.\n- Si une aide est nécessaire, cliquez sur 'AIDE' ci-dessous\n- Suivez l'ordre d'appel",
  "Alarm_Detail_Response_Protocol_Assistance": "- Connectez-vous à l'appel\n- Parlez immédiatement et proposez votre aide : \"Centrale d'alarme, que puis-je faire pour vous ?\"\n- Si une aide est nécessaire, cliquez sur 'AIDE' ci-dessous\n- Suivez l'ordre d'appel ci-dessous",
  "Alarm_Detail_Response_Protocol_Test": "Une alarme de niveau vert a été créée. La plupart du temps, aucune intervention n'est requise.\nConsultez le nom de l'alarme à gauche afin de vérifier la nature de cette alarme et de décider de la nécessité d'un suivi.",
  "Alarm_Detail_Response_Procedure": {
    "Priority": {
      "Verification": "Phase de vérification",
      "Help": "Apporter de l'aide",
      "VerificationDetail": "Je cherche à confirmer si une aide est nécessaire.",
      "HelpDetail": "J'ai confirmé qu'une aide est nécessaire.",
      "Title": "Quelle est la situation ?"
    },
    "Guide": {
      "Button": "Que dois-je faire ?",
      "Close": "Fermer",
      "Next": "Suivant",
      "ConnectAlarmCall": "Connectez-vous d'abord à l'appel d'alarme.",
      "ConnectHelperCall": "Connectez-vous à l'appel des intervenants pour parler directement avec les personnes qui ont indiqué venir aider. Vous pouvez leur parler tout de suite.",
      "Verify": "Avez-vous déjà établi si de l'aide est nécessaire ?",
      "Responder": "Contactez %{name} et indiquez si cette personne vient aider.",
      "Apr": "Appelez un agent de surveillance mobile.",
      "Retry": "Toutes les étapes sont terminées. Réessayez les étapes précédentes, par exemple quelqu'un qui n'a pas pu aider.",
      "Emergency": "Toujours bloqué ? Appelez le numéro d'urgence X-Guard pour en discuter :",
      "StillVerifying": "Je cherche encore une confirmation",
      "HelpNeeded": "J'ai établi que de l'aide est nécessaire",
      "Creator": "Contactez %{name} et indiquez si cette personne a besoin d'aide.",
      "Police": "Contactez %{name} et indiquez s'ils peuvent venir aider.",
      "AprBusy": "L'agent de surveillance mobile est encore en intervention. Attendez qu'il ait terminé avant de continuer.",
      "Recording": "Lancez la lecture et écoutez l'enregistrement pour juger si de l'aide est nécessaire."
    }
  },
  "Alarm_Detail_Response": {
    "Contact": {
      "Label": "Contact",
      "Call": {
        "Label": "Cliquez pour appeler"
      },
      "Helps": "Aide",
      "Helps_Not": "N'aide pas",
      "No_Help_Needed": "Pas besoin d'aide",
      "Needs_Help": "A besoin d'aide",
      "Unknown": "Inconnu"
    },
    "Section": {
      "AlarmCreator": {
        "Heading": "Personne ayant créé l'alarme"
      }
    },
    "Type": {
      "ACR_QR": {
        "Title": "Personnes à proximité",
        "Subtitle": "En fonction de la distance"
      },
      "ACR_NQR": {
        "Title": "Partenaires d'intervention",
        "Subtitle": "En fonction de la distance"
      },
      "ACR_RA": {
        "Title": "Zone de réaction",
        "Subtitle": "Code zone %{code}"
      },
      "ACR_PD": {
        "Title": "Police"
      },
      "ACR_PC": {
        "Title": "Contacts personnels"
      },
      "ACR_APR": {
        "Title": "Réponse professionnelle"
      }
    },
    "Missing": "La liste des intervenants a été masquée",
    "Partly_Missing": "Certains détails de la réponse sont masqués ou manquants.",
    "APR": {
      "start": "Appel",
      "cancel": "Annuler l'appel",
      "Info": {
        "Ready": {
          "Main": "Surveillance mobile disponible",
          "Sub": "Nous rechercherons automatiquement un répondant"
        },
        "InProgress": {
          "Main": "À la recherche d'une surveillance mobile"
        },
        "Finding": "L'intervenant est appelé :",
        "Found": "Intervenant désigné :",
        "Rejected": "L'alarme n'a pas pu être suivie par %{name}"
      },
      "Step": [
        {
          "InProgress": "Invité",
          "Done": "Accepté"
        },
        {
          "InProgress": "En route",
          "Done": "Sur place"
        },
        {
          "InProgress": "Sur place",
          "Done": "J'ai fini d'aider"
        }
      ],
      "Invited": "**Informations générales** - Quelle est la fréquence d'alarme ?\n- Actuele positie (wordt live bijgewerkt) **Le contact avec le surveillant est demandé dans l'acceptation**",
      "Accepted": "**Informations générales** - Quelle est la fréquence d'alarme ?\n- Actuele positie (wordt live bijgewerkt) **Contact surveillé** 1. Appelez %{number} 2. Expliquez la situation 3. Partagez votre numéro de rappel",
      "OnLocation": "**Informations partagées**\n- Qui a créé l'alarme ?\n- Position actuelle (mise à jour en direct)\n\n**Contactez le surveillant mobile**\n1. Appelez [%{formattedPhoneNumber}](tel:%{phoneNumber})\n2. Expliquez la situation\n3. Communiquez votre numéro de rappel\n\n**Attention**\n- Si le surveillant ne trouve personne ou rien, ce n'est pas une raison de clôturer l'alarme : ce n'est pas à lui d'en décider.\n- Seulement s'il confirme que l'auteur de l'alarme va bien, cela peut servir d'information pour clôturer.\n- Personne trouvé ? Continuez jusqu'à trouver quelqu'un. Nous n'abandonnons pas.",
      "Finished": "Fini",
      "FindingReplacement": "Trouver un surveillant mobile de remplacement...",
      "restart": "Démarrer un nouvel appel",
      "Explanation": "Cliquez ici pour une explication",
      "Overlay": {
        "Confirm": "Confirmer",
        "Cancel": "Annuler",
        "Confirmation": {
          "start": "Êtes-vous sûr de vouloir demander une surveillance mobile ?",
          "cancel": "Êtes-vous sûr de vouloir annuler la surveillance mobile ?",
          "restart": "Êtes-vous sûr de vouloir demander à nouveau une surveillance mobile ?"
        },
        "Title": "Réponse professionnelle"
      },
      "Replaced_By_Zone": {
        "Sub": "Le système n'a pas réussi à affecter automatiquement un intervenant professionnel. Veuillez contacter un intervenant manuellement",
        "Title": "Réponse professionnelle terminée"
      },
      "Comment": "Commentaire ci-joint : %{comment}",
      "ImagePreviews": {
        "Title": "Images jointes par le surveillant"
      },
      "DisplayPhoneNumber": "Afficher le numéro de téléphone"
    },
    "Title": "Ordre de contact"
  },
  "Alarm_Detail_Map": {
    "Marker": {
      "Current_Position": {
        "Label": "Position actuelle"
      },
      "Alarm_Position": {
        "Label": "Position de l'alarme"
      }
    },
    "AutoZoom": "Zoom automatique",
    "ImageOverlays": "Bâtiment / plans du site"
  },
  "EnvBanner": {
    "localhost": "Connecté au localhost",
    "staging": "Connecté à l'environnement test"
  },
  "Alarm_Overview_List": {
    "Closed_Alarms": {
      "No_Results": {
        "With_Filters": "Il n'y a aucune alarme acquittée qui correspond à vos filtres",
        "No_Filters": "Il n'y a aucune alarme acquittée"
      }
    },
    "Open_Alarms": {
      "No_Results": {
        "With_Filters": "Il n'y aucune alarme ouverte qui correspond à votre filtre",
        "No_Filters": "Il n'y a aucune alarme ouverte"
      }
    },
    "Filtered": {
      "Count_Visible": "%{filteredCount} des %{unfilteredCount} alarmes sont visibles",
      "Remove_Filters": "Supprimer les filtres"
    }
  },
  "Footer_TermsAndConditions": "Termes",
  "Footer_Disclaimer": "Avis de non-responsabilité",
  "Footer_Privacy": "Confidentialité",
  "AppVersion": "X-Guard Alarm Manager V%{semVer}",
  "Footer_Status": "Statut",
  "Permission": {
    "Notification": {
      "Not_Granted": "Vous n'avez pas été autorisé à recevoir des notifications navigateur."
    }
  },
  "Notification": {
    "New_Alarm": {
      "Panic": "Nouvelle alarme (rouge)",
      "Assistance": "Nouvelle alarme (orange)",
      "Test": "Nouvelle alarme (vert)"
    },
    "Multiple_New_Alarms": "Il y a plusieurs alarmes ouvertes",
    "Version_Available": "Nouvelle version disponible. Veuillez recharger la page."
  },
  "Alarm_Detail_DCC": {
    "Disconnected": {
      "Title": "Appel en cours",
      "Tooltip": "Saisissez ce code sur votre téléphone pour vous connecter.",
      "Mute_On_Join": "Mettre ma ligne en silencieux lorsqu'on me contacte"
    },
    "Connected": {
      "Title": "Vous êtes connecté à l'appel",
      "Incoming_Call_From": "Appel entrant de",
      "Connected_To": "Parties connectées",
      "Microphone": {
        "Label": "Votre micro est",
        "Muted": "En mode silencieux",
        "Enabled": "Activé"
      },
      "Self": "Vous",
      "Alarm_Maker": "Personne ayant créé l'alarme"
    },
    "Not_Created": "Il n'y a pas d'appel actif, veuillez poursuivre le protocole ci-dessous. Ne mentionnez pas cette information à la personne qui a créé l'alarme.",
    "Destroyed": "L'appel est terminé. Poursuivez la procédure d'alarme ci-dessous.",
    "Recording": {
      "Title": "Extrait audio disponible",
      "Instruction": "Écoutez les premières secondes de cet extrait afin d'évaluer si une assistance est nécessaire.  ",
      "In_Progress": "Enregistrement en cours : ce fragment sera complété pendant l'établissement de l'appel.",
      "Live": "EN DIRECT",
      "Live_Hint": "De nouveaux sons sont ajoutés à cet enregistrement.",
      "Play": "Lire",
      "Pause": "Pause",
      "Heard": "Écouté",
      "New": "Nouvel audio",
      "Unheard": "Pas encore écouté"
    },
    "Phone_Call": {
      "Alarm_Call": "Appel d'alarme en cours",
      "Helper_Call": "Appel des intervenants en cours",
      "Operator": "Opérateur",
      "Helper_Call_Connected": "Vous êtes connecté",
      "Listen_First": "Écoutez d'abord l'appel d'alarme",
      "Show_Helper_Code": "Afficher le code d'accès de l'appel des intervenants"
    },
    "Not_Created_Helper_Call": "Aucun appel actif. Connectez-vous à l'appel des intervenants et suivez le protocole ci-dessous. Ne le mentionnez pas à l'auteur de l'alarme."
  },
  "Alarm_Detail_Log_Action_Call_Result_Responding": "%{name} va intervenir",
  "Alarm_Detail_Log_Action_Call_Result_Not_Reachable": "%{name} n'a pas pu intervenir à ce moment-là",
  "Alarm_Detail_Log_Action_Call_Result_No_Response": "%{name} n'a pas répondu à l'appel",
  "Alarm_Detail_Log_Action_Call_Result_Cancelled": "Appel à %{name} annulé",
  "Unsupported_Device_Popup": {
    "Title": {
      "Mobile_Device": "L'appareil n'est pas pris en charge",
      "Resolution": "La résolution de l'écran n'est pas prise en charge"
    },
    "Body": {
      "Mobile_Device": "Ce site internet n'est pas conçu pour les appareils mobiles. Veuillez ouvrir le Gestionnaire d'alarme sur un navigateur de bureau.",
      "Resolution": "La résolution de votre navigateur n'est pas prise en charge pour l'instant. Des problèmes peuvent se produire."
    },
    "Continue": "Continuer"
  },
  "Alarm_Detail_Log_Action_Email": "E-mail envoyé à %{name}",
  "Alarm_Detail_Log_Action_Protocol_Help": "Passé au protocole 'AIDE' ",
  "Alarm_Detail_Log_Action_Protocol_Verification": "Passé au protocole 'VÉRIFICATION'",
  "Address_Accuracy": "%{accuracy} précision",
  "Address_Unknown": "Localisation inconnue",
  "Main_HiddenAlarms": "Supprimer le filtre de recherche pour afficher de nouvelles alarmes.",
  "Error_Validation_NotAValidNumber": "Ce numéro n'est pas valable",
  "Alarm": {
    "Date_Created": "Date de l'alarme"
  },
  "Address_View": "Visualiser l'adresse sur Google Maps",
  "Alarm_Detail_Chat": {
    "AlarmCreator": "Personne ayant créé l'alarme"
  },
  "Alarm_Detail_OldAlarmManager": {
    "Title1": "Cette alarme peut également être visualisée via le Gestionnaire d'alarme.",
    "Title2": "Cliquez pour ouvrir l'alarme."
  },
  "Alarm_Detail_Log_Action_Call_AlarmCreator_Result_Responding": "%{name} n'a pas besoin d'aide",
  "Alarm_Detail_Log_Action_Call_AlarmCreator_Result_Not_Reachable": "%{name} a besoin d'aide",
  "Distance_Label": {
    "Meters": "%{distance} mètres",
    "KiloMeters": "%{distance} km."
  },
  "Alarm_Detail_Log_Action_Alarm_Call_Initiated": "Appel d'urgence initié avec succès (attendre que d'autres personnes se manifestent)",
  "Alarm_Detail_Log_Action_Alarm_Call_Join": "Connecté à l'appel d'urgence",
  "Alarm_Detail_Log_Action_Alarm_Call_Leave": "Déconnecté de l'appel d'urgence",
  "Alarm_Detail_Log_Action_Alarm_Call_Start": "L'appel d'urgence a démarré",
  "Alarm_Detail_Log_Action_Alarm_Call_Ended": "L'appel d'urgence est terminé",
  "Alarm_Detail_Log_Action_Group_Call_Join": "Connecté à l'appel de groupe des intervenants",
  "Alarm_Detail_Log_Action_Group_Call_Leave": "Déconnecté de l'appel de groupe des intervenants",
  "DateTimePickerField": {
    "granularity": {
      "days": "Date",
      "hours": "Heure"
    },
    "AmPm": {
      "am": "AM",
      "pm": "PM"
    }
  },
  "Report_Code": "Code du rapport : %{code}",
  "Alarm_Detail_Helpers": {
    "Missing": "La liste des intervenants a été masquée"
  },
  "Login_SavedUsers_NeverLoggedIn": "Jamais connecté auparavant",
  "Login_SavedUsers_ConfirmRemoveToken": "Voulez-vous vraiment supprimer cet utilisateur ?",
  "Menu_OldAlarmManager": "Cliquez ici pour accéder au Gestionnaire d'alarme",
  "Alarm_Detail_Log_NewMessagesNotification": {
    "one": "Un nouveau message a été ajouté",
    "other": "%{count} nouveaux messages ont été ajoutés"
  },
  "AlarmDetails_Description": "Informations supplémentaires",
  "Alarm_Detail_Log_Action_Call_Result_Wrong_Number": "Le numéro de téléphone de %{name} est incorrect",
  "ErrorDisplay": {
    "Title": {
      "Error": "Une erreur est survenue",
      "Retrying": "Une erreur s'est produite. Nouvelle tentative"
    }
  },
  "Alarm_Overview_XgacAlarmCount": "Ouvrir les alarmes - Cliquez ici pour ouvrir",
  "Alarm_Overview_XgacAlarmCount_Sub": "Attention immédiate requise",
  "Alarm_Detail_Log_Action_Alarm_Merged": "Le bouton d'alarme a été à nouveau enfoncé par le créateur de l'alarme.\n\nLa nouvelle alarme a été fusionnée dans cette alarme pour plus de clarté.",
  "Alarm_Detail_Log_Action_Alarm_Level_Escalated_Green_Red": "Le niveau d’alarme est passé du vert au rouge.",
  "Alarm_Detail_Log_Action_Alarm_Level_Escalated_Green_Orange": "Le niveau d’alarme est passé du vert à l’orange.",
  "Alarm_Detail_Log_Action_Alarm_Level_Escalated_Orange_Red": "Le niveau d’alarme est passé de l’orange au rouge.",
  "Alarm_Detail_Log_Action_Alarm_Republished": "Redémarrage des politiques de remontée d'alarmes",
  "Alarm_Detail_Merge_History": {
    "counter": {
      "subText": "Alarmes combinées"
    },
    "title": "Cette alarme a été déclenchée %{count} fois",
    "showAllAlarms": {
      "show": {
        "other": "Afficher %{count} alarmes supplémentaires",
        "one": "Afficher 1 alarme supplémentaire"
      },
      "hide": {
        "other": "Masquer %{count} alarmes",
        "one": "Masquer 1 alarme"
      }
    }
  },
  "Helpers_Anonymous": "Anonyme",
  "Login_SavedUsers_TokenExpired": "La session utilisateur a expiré. Veuillez essayer de vous connecter à nouveau",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Cancel_Failed": "Échec de l'annulation du répondeur",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Cancel_Requested": "Demandé d'annuler le répondeur %{name}",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Accepted": "Le répondant %{name} a accepté",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Invited": "Répondant %{name} invité",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Started": "Le répondeur %{name} a démarré",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_OnLocation": "Le répondant %{name} est arrivé sur place",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Finished": "Répondeur %{name} a terminé",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Error": "Le répondeur %{name} a commis une erreur",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Cancelled": "Répondant %{name} annulé",
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Rejected": "Répondeur %{name} rejeté",
  "Version_Update_Modal": {
    "Title": "Nouvelle version disponible",
    "Body": "Une nouvelle version du gestionnaire d'alarmes X-Guard est disponible. Rechargez la page pour effectuer la mise à jour.",
    "Reload": "Recharger"
  },
  "Alarm_Detail_Log_Action_Alarm_Professional_Responder_Note": "%{name}: %{note}",
  "Alarm_Detail_Log_APR_Note_ResponderName": "Nom de la personne ayant répondu :",
  "Alarm_Detail_Log_APR_Note_PhotoCount": "Nombre de photos : %{photoCount}",
  "Alarm_Detail_Log_Ack_Photos": {
    "one": "Photo téléchargée par %{user}",
    "other": "Photos téléchargées par %{user}"
  },
  "Alarm_Detail_Chat_Title": "Chat",
  "Alarm_Detail_Chat_SentFromApp": "Envoyé depuis l'application",
  "Alarm_Detail_Chat_Typing": "%{name} est en train d'écrire",
  "Alarm_Detail_Chat_Speaking": "%{name} est en train de parler",
  "Alarm_Detail_Chat_Transcribing": "Transcription…",
  "Alarm_Detail_Chat_TranscriptWarning": "Transcrit automatiquement",
  "Alarm_Detail_Chat_ShowMore": "Afficher plus",
  "Alarm_Detail_Chat_ShowLess": "Afficher moins",
  "Alarm_Detail_Chat_ShowOriginal": "Afficher l'original",
  "Alarm_Detail_Chat_ShowTranslation": "Afficher la traduction",
  "Alarm_Detail_Chat_Deleted": "Ce message a été supprimé",
  "Alarm_Detail_Chat_Position": "Position mise à jour",
  "Alarm_Detail_Chat_Joined": "%{name} a rejoint l'appel",
  "Alarm_Detail_Chat_Left": "%{name} a quitté l'appel",
  "Alarm_Detail_Logs_Title": "Journal d'audit",
  "Alarm_Detail_Logs_ShowMore": "Consulter le journal d'audit",
  "Alarm_Detail_Logs_Empty": "Aucune action pour le moment",
  "Alarm_Detail_Logs_System": "Système",
  "Alarm_Detail_Logs_Unknown": "Action inconnue",
  "Alarm_Detail_Logs_Chat": "A envoyé un message",
  "Alarm_Detail_Logs_Notification": "Notification envoyée à %{name}",
  "Alarm_Detail_Logs_NotificationConfirmed": "Remise confirmée pour %{name}",
  "Alarm_Detail_Logs_Viewed": "%{name} a consulté cette alarme",
  "Alarm_Detail_Logs_ManualNotify": "Notification manuelle envoyée",
  "Alarm_Detail_Logs_Sms": "SMS envoyé à %{name}",
  "Alarm_Detail_Logs_Email": "E-mail envoyé à %{name}",
  "Alarm_Detail_Logs_ActionCall_initiated": "Appel lancé vers %{name}",
  "Alarm_Detail_Logs_ActionCall_cancelled": "Appel vers %{name} annulé",
  "Alarm_Detail_Logs_ActionCall_notReachable": "%{name} était injoignable",
  "Alarm_Detail_Logs_ActionCall_noResponse": "Pas de réponse de %{name}",
  "Alarm_Detail_Logs_ActionCall_responding": "%{name} répond",
  "Alarm_Detail_Logs_CallSession": "Appel %{phase}",
  "Alarm_Detail_Logs_Help_Yes": "Confirme aider",
  "Alarm_Detail_Logs_Help_No": "Refuse d'aider",
  "Alarm_Detail_Logs_Protocol_Help": "Passage au protocole d'aide",
  "Alarm_Detail_Logs_Protocol_Verification": "Passage au protocole de vérification",
  "Alarm_Detail_Logs_Acknowledge": "Alarme fermée",
  "Alarm_Detail_Logs_Merged": "L'alarme a été fusionnée",
  "Alarm_Detail_Logs_Republished": "L'alarme a été republiée",
  "Alarm_Detail_Logs_Severity": "La gravité de l'alarme a augmenté",
  "Alarm_Detail_Logs_CallMeta": "Les informations d'appel sont disponibles",
  "Alarm_Detail_Logs_Responder": "Intervenant professionnel %{name} : %{kind}",
  "Alarm_Detail_Logs_Responder_Note": "%{name} a laissé une note",
  "Alarm_Detail_Chat_OperatorNotice": "Les intervenants dans l'application vous voient comme opérateur anonyme et peuvent lire vos messages.",
  "Alarm_Detail_Logs_FullTitle": "Journal complet",
  "Alarm_Detail_Chat_Play": "Lecture",
  "Alarm_Detail_Chat_Pause": "Pause",
  "Alarm_Detail_Chat_RecordingPosition": "Position dans l'enregistrement",
  "Helpers_CallInfo": "Ce sont les personnes qui aident sur cette alarme. Personne n'est connecté : elles sont peut-être en route ou aident activement, mais n'ont pas l'alarme ouverte dans l'app. Dès qu'elles l'ouvrent, vous pouvez vous connecter avec un code d'accès. Leurs messages vocaux apparaissent dans le chat.",
  "Alarm_Detail_Logs_Operator": "Opérateur",
  "Alarm_Detail_Logs_OperatorNumber": "Opérateur #%{number}",
  "Alarm_Detail_Export": {
    "Button": "Exporter les informations de l'alarme",
    "Sheet_Alarm": "Alarme",
    "Sheet_Log": "Chronologie",
    "Sheet_Chat": "Chat",
    "Sheet_Call_Events": "Événements d'appel",
    "Sheet_Participants": "Participants",
    "Sheet_Helpers": "Intervenants",
    "Sheet_Responders": "Ordre de contact",
    "Sheet_Calls": "Appels",
    "Column_Field": "Élément",
    "Column_Value": "Valeur",
    "Failed": "L'exportation a échoué",
    "Column_Time": "Heure",
    "Column_Who": "Qui",
    "Column_Event": "Événement",
    "Column_Details": "Détails",
    "Column_Message": "Message",
    "Column_Name": "Nom",
    "Column_Answer": "Réponse",
    "Column_Group": "Groupe",
    "Row_Alarm": "Alarme",
    "Row_Severity": "Gravité",
    "Row_Status": "Statut",
    "Row_Ack_Comment": "Commentaire à la clôture",
    "Row_Exported": "Exporté le",
    "Status_Open": "Ouvert",
    "Status_Closed": "Clôturé",
    "Severity_Red": "Rouge",
    "Severity_Orange": "Orange",
    "Severity_Green": "Vert",
    "Answer_None": "Pas encore de réponse",
    "Name_Anonymous": "Anonyme",
    "Message_Voice": "Message vocal"
  },
  "Alarm_Detail_Logs_Group": "Grouper par personne",
  "Alarm_Detail_Logs_Confirmed": "Confirmé",
  "Alarm_Detail_Logs_ViewedTicket": "Consulté",
  "Alarm_Detail_Logs_CallConnected": "Dans l'appel",
  "Alarm_Detail_Logs_CallStarted": "A démarré l'appel",
  "Alarm_Detail_Logs_CallOngoing": "en cours",
  "Alarm_Detail_Logs_Summoned": "Alerté",
  "Alarm_Detail_Logs_ChatMessages_One": "%{count} message de chat envoyé",
  "Alarm_Detail_Logs_ChatMessages_Other": "%{count} messages de chat envoyés",
  "Alarm_Detail_Logs_AudioMessages_One": "%{count} message vocal envoyé",
  "Alarm_Detail_Logs_AudioMessages_Other": "%{count} messages vocaux envoyés",
  "Alarm_Detail_Logs_MessageAudio": "A envoyé un message vocal",
  "Alarm_Detail_Logs_Messages": "Activité de l'appel",
  "Alarm_Detail_Logs_CallSession_started": "A démarré un appel",
  "Alarm_Detail_Logs_CallSession_join": "A rejoint l'appel",
  "Alarm_Detail_Logs_CallSession_leave": "A quitté l'appel",
  "Alarm_Detail_Logs_CallSession_ended": "Appel terminé",
  "Alarm_Detail_Logs_CallType_alarmCall": "Appel d'alarme",
  "Alarm_Detail_Logs_CallType_helperCall": "Appel des répondants",
  "Alarm_Detail_Logs_AckSurvey": "Enquête : %{text}",
  "Alarm_Detail_Logs_AckSystem": "Fermé automatiquement : %{reason}",
  "Alarm_Detail_Logs_Help_Revised": "A modifié sa réponse",
  "Alarm_Detail_Logs_PositionUpdates_One": "%{count} mise à jour de position",
  "Alarm_Detail_Logs_PositionUpdates_Other": "%{count} mises à jour de position",
  "Alarm_Detail_Logs_Recording": "Enregistrement du premier moment",
  "Alarm_Detail_Logs_RecordingCount": "Enregistrement du premier moment (%{duration})",
  "Alarm_Detail_Logs_Role_creator": "Créateur de l'alarme",
  "Alarm_Detail_Logs_Role_helper": "Répondant",
  "Alarm_Detail_Logs_Role_operator": "Opérateur",
  "Alarm_Detail_Logs_Role_centralist": "Opérateur de la centrale",
  "Alarm_Detail_Logs_Count_One": "%{count} entrée",
  "Alarm_Detail_Logs_Count_Other": "%{count} entrées",
  "Alarm_Detail_Chat_JoinedAndLeft": "%{name} a brièvement rejoint puis quitté l'appel (%{count} changements)",
  "Alarm_Detail_Chat_Rejoined": "%{name} a de nouveau rejoint l'appel (%{count} changements)",
  "Alarm_Detail_Logs_Filter_People": "Filtrer par personne",
  "Alarm_Detail_Logs_Filter_Groups": "Filtrer par groupe",
  "Alarm_Detail_Logs_Filter_From": "De",
  "Alarm_Detail_Logs_Filter_To": "Jusqu'à",
  "Alarm_Detail_Logs_Range_Placeholder": "Période",
  "Alarm_Detail_Logs_Range_Today": "Aujourd'hui",
  "Alarm_Detail_Logs_Range_Day": "Dernières 24 heures",
  "Alarm_Detail_Logs_Range_Week": "7 derniers jours",
  "Alarm_Detail_Logs_Range_Month": "30 derniers jours",
  "Alarm_Detail_Logs_Range_Clear": "Effacer les dates",
  "Alarm_Detail_Logs_Fullscreen": "Plein écran",
  "Alarm_Detail_Logs_Timeline": "Afficher en chronologie",
  "Alarm_Detail_Logs_Created": "Alarme créée",
  "Alarm_Detail_Logs_Escalated": "Renvoyée à la centrale d'alarme",
  "Alarm_Detail_Logs_Summon_Push": "Notification push",
  "Alarm_Detail_Logs_Summon_Sms": "SMS",
  "Alarm_Detail_Logs_Summon_Email": "E-mail",
  "Alarm_Detail_Logs_Summon_Call_initiated": "Appelé",
  "Alarm_Detail_Logs_Summon_Call_cancelled": "Appel annulé",
  "Alarm_Detail_Logs_Summon_Call_notReachable": "Injoignable",
  "Alarm_Detail_Logs_Summon_Call_noResponse": "Pas de réponse",
  "Alarm_Detail_Logs_Summon_Call_responding": "Répond",
  "Alarm_Detail_Logs_Helping": "Vient aider"
} as const

export default language